// extracted by mini-css-extract-plugin
export var backdropBlur = "_k0-0";
export var contentCard = "_k0-5";
export var frame = "_k0-2";
export var image = "_k0-4";
export var imagePane = "_k0-3";
export var modal = "_k0-1";